export default __webpack_public_path__ + "static/media/loader-spinner.96c944d2.gif";